import '../scss/main.scss';
import '../scss/career.scss';
import common from './_common.js';
import Helpers from './util/helpers';

const isBot = /Googlebot|Google-Structured-Data-Testing-Tool|Bingbot|AdIdxBot|BingPreview|DuckDuckGo|DuckDuckBot|facebookexternalhit|LinkedInBot/i.test(
  window.navigator.userAgent
);

let params = Helpers.deparam(window.location.search, true);
let el = document.querySelector('.single-job .all-careers-btn');
// Check to see if we have a return param and if so update the return url.
if (params.return && decodeURI(params.return).startsWith('/')) {
  if (el) {
    let count = 0,
      str = '';
    Object.keys(params).forEach(function(key) {
      if (key !== 'return') {
        str += (count > 0 ? '&' : '') + key + '=' + encodeURIComponent(params[key]);
        count++;
      }
    });
    el.href = decodeURI(params.return) + '?' + str + '#jobs';
  }
  // in case we don't have return query and QueryString is not empty
} else if (document.location.search !== '') {
  el.href = el.href + window.location.search + '#jobs';
}

if (window.Grnhse && window.Grnhse.Iframe) {
  let matches = location.pathname.match(/\/(\d+)-?/);
  let jobId = matches ? matches[1] : null;
  if (jobId) {
    // TODO we can remove this after we remove the legacy site and we enable this
    // in https://wundermanthompson.greenhouse.io/configure/dev_center/4008593002/config
    window.Grnhse.Settings.scrollOnLoad = false;

    // Don't load Greenhouse iframe for bots, it duplicates structured data,
    // and has caused errors with SEO.
    if (!isBot) {
      setTimeout(() => {
        // Listen for GH iframe submit messages.
        window.addEventListener('message', (event) => {
          if (event.data === 'greenhouse.confirmation') {
            document.querySelector('.single-job .privacy-disclaimer').style.display = 'none';
            common.vue.trackEvent('Job Application Submission', {
              job_location: window.pageData.jobLocation,
              job_title: window.pageData.jobTitle
            });
          }
        });

        try {
          window.Grnhse.Iframe.load(jobId);
        } catch (e) {
          // Silence Greenhouse iframe errors.
        }
      }, 100);
    }
  }
}
